import React from "react";
import { Page, Document } from "react-pdf";

class ApMobileSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleClick = this.handleClick.bind(this);
  }

  renderContent() {
    const { documents, selectDocument, page } = this.props;

    const docs = documents.map((value, index) => {
      return (
        <File
          key={value.id}
          doc={value}
          isSelected={value.id === page.id}
          onSelect={pageIndex => selectDocument(index, pageIndex)}
        />
      );
    });

    return <div>{docs}</div>;
  }

  handleClick(event) {
    if (event.target === event.currentTarget) {
      this.props.onClose();
    }
  }

  render() {
    const { visible, project } = this.props;

    const classNames =
      "ApMobileSidebarContainer" +
      (visible ? "" : " ApMobileSidebarContainer-Hidden");

    const classNames2 =
      "ApMobileSidebar" + (visible ? "" : " ApMobileSidebar-Hidden");

    return (
      <div className={classNames} onTouchStart={this.handleClick}>
        <div className={classNames2}>
          <div id="Head">
            <i className="fas fa-times" onClick={() => this.props.onClose()} />
            <div className="Spacer-HB" />
            <p>{project.name}</p>
          </div>
          <div className="ApMobileSidebarFileList">{this.renderContent()}</div>
        </div>
      </div>
    );
  }
}

function File(props) {
  const header = (
    <div className="ApMobileSideBarHeader">
      <p>{props.doc.name}</p>
      <span>
        <p>{/*TODO props.doc*/}</p>
        <i className="far fa-file-alt" />
      </span>
    </div>
  );

  /*
  const pages = props.doc.pages.map((value, index) => {
    return <Page key={value.id} pageIndex={index} page={value} />;
  });
*/
  function pageGroupImage(doc) {
    return (
      <div className="ApMobileSideBarPageGroup">
        <ImgPage
          pageIndex={0}
          doc={doc}
          onClick={() => props.onSelect(0)}
          isSelected={props.isSelected}
        />
      </div>
    );
  }

  function pageGroupPdf(doc) {
    return (
      <Document className="ApMobileSideBarPageGroup" file={doc.src}>
        <Page
          className="ApMobileSideBarPage"
          pageNumber={1}
          renderAnnotations={false}
          renderTextLayer={false}
          onRenderSuccess={() => {}}
          doc={doc}
        />
      </Document>
    );
  }

  const pageGroup = props.doc.type.startsWith("image/")
    ? pageGroupImage(props.doc)
    : pageGroupPdf(props.doc);

  return (
    <div>
      {header}
      <div className="ApMobileSideBarPageContainer">{pageGroup}</div>
    </div>
  );
}

function ImgPage(props) {
  const doc = props.doc;
  const thumbnailUrl = doc.thumbnail;

  const classes = `ApMobileSideBarPage${
    props.isSelected ? " ApMobileSideBarPageSelected" : ""
  }`;

  return (
    <div className={classes} onClick={props.onClick}>
      <p>{props.pageIndex + 1}</p>
      <img src={thumbnailUrl} />
    </div>
  );
}

export default ApMobileSidebar;
//http://s1.studylibde.com/store/data/020860366_1-b1cc2f4051e7a3677ab4ef7cb7e95fd9.png



// WEBPACK FOOTER //
// ./src/components/approval/mobile/ApMobileSidebar.js